import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "align"];
import { DATA_TRANSITIONAL_COMPONENT_ATTRIBUTE } from '../../constants';
import { Box } from '../Box';

/**
 * CHANGE:
 * - `size` prop removed as it is not used outside of UIComponents.
 */
import { jsx as _jsx } from "react/jsx-runtime";
export const MediaRight = _ref => {
  let {
      children,
      align
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(Box, Object.assign({
    order: 3,
    minInlineSize: "0",
    alignItems: align
  }, rest, {
    [DATA_TRANSITIONAL_COMPONENT_ATTRIBUTE]: 'MediaRight',
    children: children
  }));
};
MediaRight.displayName = 'MediaRight';